import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

const omnichannelGetConversationExperienceId =
	'service-management.help-center.omnichannel.get-conversation';

export const omnichannelGetConversationExperience = new UFOExperience(
	omnichannelGetConversationExperienceId,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
